import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/* 项目全局State */
const state = {
  imgUrl: ''
}

/* Store实例 */
export default new Vuex.Store({
  state
})



// WEBPACK FOOTER //
// ./src/store/index.js